export const styles = {
    hotelCategoryText: {
        marginRight: 4
    }
};

export type ComponentJSSClasses = typeof styles;
